import { useQuery } from "@tanstack/react-query";
import { BulkTestReport } from "@/model";
import bulkTestRepository from "@/repository/bulkTestRepository";


const getData = async (agentId: number, testId: string) => {
    const res = await bulkTestRepository.read(agentId, testId);
    return res.data.data;
};

export const useBulkTestReport = (agentId: number, testId: string) => {
    return useQuery<BulkTestReport>({
        queryKey: ["bulk-test", "agent", agentId, "test", testId],
        queryFn: async () => getData(agentId, testId),
        retry: false
    });
};
